export default "__VITE_ASSET__iHjMpwSU__"